import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button
  } from '@mui/material'
  import { useNavigate } from 'react-router-dom'
import { GREY, PRIMARY, SECONDARY } from 'theme/palette'
  
  interface HeadsUpDialogProps {
	open: boolean
	title?: string
	message: string
	onAcknowledge?: () => void
	redirectTo?: string
  }
  
  const HeadsUpDialog = ({
	open,
	title = 'We need to review the ACN',
	message,
	onAcknowledge,
	redirectTo
  }: HeadsUpDialogProps) => {
	const navigate = useNavigate()
  
	const handleOkClick = () => {
	  if (onAcknowledge) {
		onAcknowledge()
	  } else if (redirectTo) {
		navigate(redirectTo)
	  }
	}
  
	return (
	  <Dialog
		open={open}
		onClose={() => {}}
		onBackdropClick={() => {}} // blocks backdrop dismiss
		disableEscapeKeyDown
		PaperProps={{
		  sx: {
			minWidth: '620px',
			fontSize: '16px',
			borderRadius: '8px',
			overflow: 'hidden'
		  }
		}}
	  >
		<DialogTitle
		  sx={{
			backgroundColor: SECONDARY.buttons,
			color: PRIMARY.contrastText,
			fontWeight: 700,
			fontSize: '20px'
		  }}
		>
		  {title}
		</DialogTitle>
  
		<DialogContent
		  sx={{
			backgroundColor: GREY[0],
			paddingTop: '20px !important',
			color: SECONDARY.buttons,
			fontSize: '16px',
			padding: '24px',
			whiteSpace: 'pre-wrap'
		  }}
		>
		  {message}
		</DialogContent>
  
		<DialogActions sx={{ justifyContent: 'flex-end', padding: '16px 24px' }}>
		  <Button
			variant="contained"
			color="primary"
			onClick={handleOkClick}
			sx={{ padding: '10px 24px', borderRadius: '6px', fontWeight: 600 }}
		  >
			OK
		  </Button>
		</DialogActions>
	  </Dialog>
	)
  }
  
  export default HeadsUpDialog
  